import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/calendar' },
    { path: '/calendar', component: () => import('./views/CalendarView.vue'), meta: { title: 'Calendrier' } },
    { path: '/my-leaves', component: () => import('./views/MyLeavesView.vue'), meta: { title: 'Mes congés' } },
    { path: '/team', component: () => import('./views/TeamView.vue'), meta: { title: 'Équipe' } },
    { path: '/heatmap', component: () => import('./views/HeatmapView.vue'), meta: { title: 'Heatmap' } },
    { path: '/feeds', component: () => import('./views/FeedsView.vue'), meta: { title: 'Mes flux iCal' } },
    { path: '/settings', component: () => import('./views/SettingsView.vue'), meta: { title: 'Paramètres', admin: true } },
    { path: '/admin/users', component: () => import('./views/AdminUsersView.vue'), meta: { title: 'Utilisateurs', admin: true } },
    { path: '/admin/users/:id/leaves', component: () => import('./views/UserLeavesView.vue'), meta: { title: 'Congés utilisateur', admin: true } },
    { path: '/admin/departments', component: () => import('./views/AdminDepartmentsView.vue'), meta: { title: 'Départements', admin: true } },
    // Legacy redirects from the previous standalone /api-tokens and /admin/settings routes.
    { path: '/api-tokens', redirect: '/settings' },
    { path: '/admin/settings', redirect: '/settings' },
    { path: '/:pathMatch(.*)*', redirect: '/calendar' },
  ],
});

// Defence-in-depth for admin-only routes — the sidebar already hides these
// entries for non-admins, but direct-URL access must also be refused.
// The server's `requireAdmin` preHandler is the real gate; this guard just
// avoids flashing an admin view before the API replies 403.
router.beforeEach(async (to) => {
  if (!to.meta.admin) return true;
  const auth = useAuthStore();
  if (auth.loading) await auth.fetchMe();
  return auth.user?.isAdmin ? true : { path: '/calendar' };
});
